// extracted by mini-css-extract-plugin
export var container = "_5z-1";
export var cornerButtonContainer = "_5z-5";
export var disabled = "_5z-2";
export var fileContainer = "_5z-4";
export var hiddenInput = "_5z-3";
export var widthContainer = "_5z-0";